import { render, staticRenderFns } from "./BodyDescription.vue?vue&type=template&id=4b4ed5ee&scoped=true"
import script from "./BodyDescription.vue?vue&type=script&lang=js"
export * from "./BodyDescription.vue?vue&type=script&lang=js"
import style0 from "./BodyDescription.vue?vue&type=style&index=0&id=4b4ed5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ed5ee",
  null
  
)

export default component.exports